import { InjectionToken } from "@angular/core";

/** Public app configuration. Never put service-account keys or APNs private keys here. */
export interface MessagingConfig {
  /** Device diagnostics in JS console; always disabled in production. */
  debug?: boolean;
  enabled: boolean;
  requestPermissionOnStartup: boolean;
  registrationPath: string;
  requestTimeoutMs: number;
  androidChannel: { id: string; name: string; description: string };
}

export const MESSAGING_CONFIG = new InjectionToken<MessagingConfig>("MESSAGING_CONFIG", {
  providedIn: "root",
  factory: () => ({
    debug: true,
    enabled: true,
    requestPermissionOnStartup: true,
    // Implement this authenticated PUT/DELETE contract in the backend before release.
    registrationPath: "register/push-device",
    requestTimeoutMs: 10000,
    // Keep id in sync with AndroidManifest.xml default_notification_channel_id.
    androidChannel: { id: "orbitta_push", name: "Orbitta", description: "Notificações do Orbitta" },
  }),
});
